// Controller connectivity banner (DESIGN_SPEC §10.1, §10.15), the only page-level message. It shows
// while GET /v1/nodes (polled every 5 s for the nav) gets no response or a 5xx:
//   × CONTROLLER UNREACHABLE   502 from /v1/nodes · retrying in 4 s   Retry now
// Sticky under the nav on raised paper; ink, never red. The poll restarts 5 s after each failure,
// so the countdown is exact; the alert region excludes the ticking part.
//   <Banner />
import { NODES_POLL_MS, useClock, useNodes } from "@/hooks";
import { isApiError } from "@/lib/api";

function unreachable(err: unknown): string | null {
  if (isApiError(err)) return err.status >= 500 ? `${err.status} from ${err.path}` : null;
  return err ? "no response from /v1/nodes" : null;
}

export function Banner() {
  const nodes = useNodes();
  const detail = nodes.isError ? unreachable(nodes.error) : null;
  const now = useClock(1000, detail !== null);
  if (detail === null) return null;
  const secs = Math.max(1, Math.ceil((nodes.errorUpdatedAt + NODES_POLL_MS - now) / 1000));
  return (
    <div className="banner">
      <div className="page">
        <span role="alert" className="inline-flex flex-wrap items-baseline gap-x-3.5">
          <b>× Controller unreachable</b>
          <span>{detail}</span>
        </span>
        <span className="text-ink-mute">{nodes.isFetching ? "retrying…" : `retrying in ${secs} s`}</span>
        <button type="button" className="lnk ml-auto" disabled={nodes.isFetching} onClick={() => void nodes.refetch()}>
          Retry now
        </button>
      </div>
    </div>
  );
}
